import {getTestProps} from '@benchling/js-test-utils';
import {Button, Stack, Text, Title, createStyles} from '@mantine/core';
import React from 'react';

import staticURL from 'lib/staticURL';
import {SIGNUP_COMPLETE_ILLUSTRATION} from 'model-hub/lib/modelHubIllustrations';

import {CREDIT_TIERS, type EmailType} from '../constants';
import {
  SIGNUP_BUTTON_SIZE,
  SIGNUP_COMPACT_STACK_SPACING,
  SIGNUP_FORM_STACK_SPACING,
  SIGNUP_STEP_STACK_SPACING,
  useSignupStepStyles,
} from '../signupUi';

interface SuccessStepProps {
  emailType: EmailType;
  firstName: string;
  onGoToModelHub: () => void;
}

export default function SuccessStep({emailType, firstName, onGoToModelHub}: SuccessStepProps): JSX.Element {
  const {classes: illustrationClasses} = useStyles();
  const {classes: stepClasses} = useSignupStepStyles();
  const tier = CREDIT_TIERS[emailType];

  return (
    <Stack align="center" spacing={SIGNUP_STEP_STACK_SPACING}>
      <Stack align="center" spacing={SIGNUP_FORM_STACK_SPACING}>
        {/* Decorative: the "You're in" title below carries the meaning. */}
        <img
          alt=""
          aria-hidden={true}
          className={illustrationClasses.illustration}
          height={SIGNUP_COMPLETE_ILLUSTRATION.intrinsicHeight}
          src={staticURL(SIGNUP_COMPLETE_ILLUSTRATION.path)}
          width={SIGNUP_COMPLETE_ILLUSTRATION.intrinsicWidth}
          {...getTestProps({component: 'SuccessStep', element: 'illustration'})}
        />
        <Stack align="center" spacing={SIGNUP_COMPACT_STACK_SPACING}>
          <Title order={2}>You&apos;re in{firstName.trim() !== '' ? `, ${firstName.trim()}` : ''}.</Title>
          <Text align="center" className={stepClasses.subtitle}>
            Your workspace is ready with {tier.predictionsPerMonth.toLocaleString()} free predictions every
            month.
          </Text>
        </Stack>
      </Stack>
      <Button fullWidth={true} size={SIGNUP_BUTTON_SIZE} onClick={onGoToModelHub}>
        Go to Model Hub
      </Button>
    </Stack>
  );
}

const useStyles = createStyles(() => ({
  illustration: {
    height: SIGNUP_COMPLETE_ILLUSTRATION.displayHeightPx,
    userSelect: 'none',
    width: 'auto',
  },
}));
